import { render } from "./DataConnections.vue?vue&type=template&id=a10cdbf6&scoped=true"
import script from "./DataConnections.vue?vue&type=script&lang=js"
export * from "./DataConnections.vue?vue&type=script&lang=js"

import "./DataConnections.vue?vue&type=style&index=0&id=a10cdbf6&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a10cdbf6"]])

export default __exports__